<div class="ion-padding-top"></div>
<ion-refresher (ionRefresh)="doRefresh($event)" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
</ion-refresher>

<div class="scoreboard-margin ion-padding-start ion-padding-end" *ngFor="let tie of ties">
    <app-tie-scorecard [tie]="tie" [isListView]="true"></app-tie-scorecard>
</div>

<div class="ion-padding content-width" [hidden]="!isLoading" *ngFor="let x of [0, 1, 2]">
    <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
</div>

<app-empty-page *ngIf="!ties.length && !isLoading" [text]="tie_placeholder" iconName="people"></app-empty-page>

<ion-infinite-scroll *ngIf="getMoreTies" (ionInfinite)="doInfinite($event)">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Load more data...">
    </ion-infinite-scroll-content>
</ion-infinite-scroll>